import React, { Component } from "react";
import api from "../../config/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  debitsSelectedComp,
  openSnackComp,
  registerDebitAutomaticComp,
} from "../../actions";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography, Paper, Divider, Button } from "@material-ui/core";
import Snackbar from "../../components/Snackbar";
import SelectItem from "../../components/SelectItem";
import InputAccountBank from "../../components/InputAccountBank";
import TableRegisterAutomaticDebitsSelecteds from "../../components/TableRegisterAutomaticDebitsSelecteds";
import CheckboxDebitAutomaticRegister from "../../components/CheckboxDebitAutomaticRegister";
import ButtonTypeName from "../../components/ButtonTypeName";
import { checkDebitsExist } from "../../helper/checkDebitsExist";
import { handleCreateObj } from "../../helper/createObjDA";

const styles = (theme) => ({
  title: {
    position: "relative",
    marginTop: 30,
    textAlign: "center",
  },
  buttonBack: {
    position: "absolute",
    top: 5,
    left: 30,
  },
  container: {
    padding: "20px 35px",
  },
  inputs: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "20px 0",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  inputsItem: {
    width: "initial",
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "center",
    },
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  paper: {
    width: "100%",
    padding: 15,
  },
  paperTitle: {
    fontSize: 16,
  },
  inputsBankGroup: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    marginBottom: 30,
  },
  relacao: {
    padding: "25px 0 15px 0",
    fontSize: 16,
  },
});

export class DebitsAutomaticRegister extends Component {
  state = {
    banks: [],
    bankSelected: 0,
    bankAgency: 0,
    bankAccount: 0,
    bankDV: "",
    msg: "",
    bankMixed: true,
    checkboxAutorization: false,
    checkboxNonMixed: false,
  };

  componentDidMount() {
    checkDebitsExist(this.props);
    this.handleGetBanks();
    handleCreateObj(this.props);
  }

  handleGetBanks = () => {
    api
      .get("Bancos/Consultar?opcao=2")
      .then((banksGroup) => {
        this.setState({
          banks: banksGroup.data,
        });
      })
      .catch((error) => {});
  };

  getBankCode = (item) => {
    let typeBankMixed = false;

    this.state.banks.forEach((bank) => {
      if (bank.CodigoBanco === item) {
        typeBankMixed = bank.PermiteCadastramentoMisto;
      }
    });

    this.setState({
      bankSelected: item,
      bankMixed: typeBankMixed,
    });
  };

  getBankAgency = (item) => {
    this.setState({ bankAgency: item });
  };

  getBankAccount = (item) => {
    this.setState({ bankAccount: item });
  };

  getBankDV = (item) => {
    this.setState({ bankDV: item });
  };

  getCheckboxAutorization = (item) => {
    this.setState({ checkboxAutorization: item });
  };

  getCheckboxNonMixed = (item) => {
    this.setState({ checkboxNonMixed: item });
  };

  handleCheckRegisterIsValid = () => {
    const {
      bankSelected,
      bankAgency,
      bankAccount,
      bankDV,
      checkboxAutorization,
      checkboxNonMixed,
    } = this.state;
    let statusInputs = false;
    let statusCheckboxes = false;
    let registerDebit = this.props.registerDebitAutomaticValue;

    if (
      bankSelected !== 0 &&
      bankAgency !== 0 &&
      bankAccount !== 0 &&
      bankDV !== ""
    ) {
      statusInputs = true;

      registerDebit.CodigoBanco = parseInt(bankSelected);
      registerDebit.Agencia = parseInt(bankAgency);
      registerDebit.Conta = parseInt(bankAccount);
      registerDebit.Digito = bankDV;
    } else {
      this.setState(
        {
          msg: "Você deve preencher todos os campos obrigatórios.",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }
    let permiteCadastramentoMisto = false;
    this.state.banks.forEach((item) => {
      if (
        item.CodigoBanco === bankSelected &&
        item.PermiteCadastramentoMisto === true
      ) {
        permiteCadastramentoMisto = true;
      }
    });

    if (statusInputs) {
      if (
        (checkboxAutorization && permiteCadastramentoMisto) ||
        (checkboxAutorization && checkboxNonMixed)
      ) {
        statusCheckboxes = true;
      } else {
        if (
          permiteCadastramentoMisto ||
          (!checkboxAutorization && checkboxNonMixed) ||
          (checkboxAutorization && !checkboxNonMixed)
        ) {
          this.setState(
            {
              msg: "Você precisar marcar a opção.",
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        } else {
          this.setState(
            {
              msg: "Você precisar marcar todas as opções.",
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        }
      }
    }

    if (statusInputs && statusCheckboxes) {
      this.props.registerDebitAutomaticComp(registerDebit);
      this.handleRegisterDebit();
    }
  };

  handleRegisterDebit = () => {
    api
      .post(
        "Debitos/CadastrarDebitoAutomatico",
        this.props.registerDebitAutomaticValue
      )
      .then((DARegistered) => {
        if (DARegistered.data.Erros.length > 0) {
          this.setState(
            {
              msg: DARegistered.data.Erros[0],
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        } else {
          this.setState(
            {
              msg: "Débito(s) cadastrado(s) com sucesso!",
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        }
      })
      .catch({});
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Snackbar message={this.state.msg} />

        <div className={classes.selectedDebits}>
          <Grid container className={classes.container}>
            <Paper className={classes.paper}>
              <div style={{ marginTop: "110px" }}>
                <div className={classes.menuGroup}>
                  <Link to="/debito-automatico" className={classes.linkGroup}>
                    <Button variant="contained" className={classes.button}>
                      <span>{"<"} VOLTAR</span>
                    </Button>
                  </Link>
                </div>
                <p>
                  Não serão aceitas conta salário e conta conjunta do tipo não
                  solidária para esse tipo de cadastro.
                </p>
              </div>

              <div className={classes.inputsBankGroup}>
                <SelectItem
                  typeSelect={1}
                  getBankCode={this.getBankCode}
                  banks={this.state.banks}
                />
                <InputAccountBank
                  inputType={1}
                  getBankAgency={this.getBankAgency}
                />
                <InputAccountBank
                  inputType={2}
                  getBankAccount={this.getBankAccount}
                />
                <InputAccountBank inputType={3} getBankDV={this.getBankDV} />
              </div>

              <Divider />

              <Typography
                variant="h6"
                color="textSecondary"
                className={classes.relacao}
              >
                RELAÇÃO
              </Typography>
              <TableRegisterAutomaticDebitsSelecteds
                rows={this.props.debitsSelectedValue}
                typeTable={1}
                props={this.props}
              />
            </Paper>

            <div>
              <CheckboxDebitAutomaticRegister
                type="debitoEmConta"
                getCheckboxAutorization={this.getCheckboxAutorization}
              />
            </div>
            {!this.state.bankMixed && (
              <CheckboxDebitAutomaticRegister
                type="bancoMisto"
                getCheckboxNonMixed={this.getCheckboxNonMixed}
              />
            )}

            <div className={classes.inputs}>
              <div
                className={classes.inputsItem}
                onClick={this.handleCheckRegisterIsValid}
              >
                <ButtonTypeName typeButton={4} />
              </div>
            </div>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  registerDebitAutomaticValue: store.cardDebitState.registerDebitAutomaticValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { debitsSelectedComp, openSnackComp, registerDebitAutomaticComp },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(DebitsAutomaticRegister)
);
